import React from "react";
import { Card, CardContent, Typography, Box } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 12px rgba(0, 0, 0, 0.15)",
    },
  },
  content: {
    padding: theme.spacing(2),
    width: "100%",
  },
  icon: {
    fontSize: "2.5rem",
    marginBottom: theme.spacing(1),
  },
  value: {
    fontSize: "2rem",
    fontWeight: "bold",
    margin: theme.spacing(1, 0),
  },
  title: {
    fontSize: "0.9rem",
    color: "#666",
    fontWeight: 500,
  },
  colorBar: {
    height: "4px",
    width: "100%",
    borderRadius: "12px 12px 0 0",
  },
}));

interface IndicatorCardProps {
  title: string;
  value: number | string;
  color?: string;
  icon?: string;
  trend?: number; // Opcional: percentual de crescimento
}

const IndicatorCard: React.FC<IndicatorCardProps> = ({
  title,
  value,
  color = "#2196F3",
  icon = "📊",
  trend,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Box
        className={classes.colorBar}
        style={{ backgroundColor: color }}
      />
      <CardContent className={classes.content}>
        <div className={classes.icon}>{icon}</div>
        <Typography className={classes.value}>{value}</Typography>
        <Typography className={classes.title}>{title}</Typography>
        {trend !== undefined && (
          <Typography
            style={{
              color: trend > 0 ? "#4CAF50" : "#F44336",
              fontSize: "0.85rem",
              marginTop: "0.5rem",
            }}
          >
            {trend > 0 ? "↑" : "↓"} {Math.abs(trend)}%
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default IndicatorCard;
